import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {DashboardGestaoComponent} from "./pages/dashboard-gestao/dashboard-gestao.component";
import {ListaComponent} from "./pages/financeiro/lista/lista.component";

const routes: Routes = [
  { path: "", component: DashboardGestaoComponent},
  { path: "financeiro", component: ListaComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GestaoRoutingModule { }
